module.exports = __webpack_public_path__ + "static/media/icon-challenge.840bb9d3.png";